export default "__VITE_ASSET__4HWOGuix__"